import { gql } from '@apollo/client'
import { POST_CARD_FIELDS } from '../fragments/postCardFields'

export const GET_CHANNEL_TIMELINE = gql`
  query GetChannelTimeline($limit: Int, $offset: Int) {
    channelTimeline(limit: $limit, offset: $offset) {
      ...PostCardFields
    }
  }
  ${POST_CARD_FIELDS}
`
